exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loading{text-align:center;background:transparent;color:#999;height:1.28rem;line-height:1.06667rem;font-size:0.32rem}\n", ""]);

